import { InfoOutlineIcon } from '@carboncopyco/icons';
import {
  ColorHex,
  DropdownItem as DropdownItemComponent,
  Popover,
  TextBase,
} from '@carboncopyco/ui';
import classNames from 'classnames';
import { type ReactNode, useState } from 'react';

interface IDropdownItem {
  title: string;
  subtitle: string;
  icon: ReactNode;
  additionalInfo?: string;
  isDisabled?: boolean;
  disabledMessage?: string;
  onClick?: (e: MouseEvent) => void;
}

const DropdownItem = ({
  icon,
  title,
  subtitle,
  additionalInfo,
  isDisabled = false,
  disabledMessage,
  onClick,
}: IDropdownItem) => {
  const [isInfoPopoverOpen, setIsInfoPopoverOpen] = useState(false);
  const [isDisabledPopoverOpen, setIsDisabledPopoverOpen] = useState(false);

  const Content = (
    <div
      className="py-2 px-1.5"
      onMouseEnter={() => setIsDisabledPopoverOpen(true)}
      onMouseLeave={() => setIsDisabledPopoverOpen(false)}
    >
      <DropdownItemComponent
        onClick={onClick}
        disabled={isDisabled}
        asChild={true}
      >
        <div
          className={classNames('flex py-2 px-1.5 rounded-md', {
            'bg-ds-natural-200-a': isDisabled,
          })}
        >
          {icon}
          <div className="flex flex-col pl-1.5 items-start ">
            <span className="">
              <TextBase
                label={title}
                color={
                  !isDisabled ? 'text-ds-natural-600' : 'text-ds-natural-200'
                }
              />
              {additionalInfo && (
                <Popover
                  open={isInfoPopoverOpen}
                  triggerElement={
                    <div
                      className="pl-1"
                      onMouseEnter={() => setIsInfoPopoverOpen(true)}
                      onMouseLeave={() => setIsInfoPopoverOpen(false)}
                    >
                      <InfoOutlineIcon
                        size={12}
                        color={ColorHex.natural400}
                      />
                    </div>
                  }
                  arrow={true}
                  width={240}
                  align="start"
                >
                  <div className="flex flex-col justify-center items-center p-3 cursor-auto">
                    <TextBase
                      label={additionalInfo}
                      color="text-ds-natural-400"
                    />
                  </div>
                </Popover>
              )}
            </span>
            <TextBase
              label={subtitle}
              ellipsis
              color={
                !isDisabled ? 'text-ds-natural-400' : 'text-ds-natural-200'
              }
            />
          </div>
        </div>
      </DropdownItemComponent>
    </div>
  );

  return isDisabled && disabledMessage ? (
    <Popover
      open={isDisabledPopoverOpen}
      arrow={true}
      align="center"
      side="right"
      asChild={true}
      triggerElement={Content}
    >
      <div className="flex flex-col justify-center items-center p-3 cursor-auto">
        <TextBase
          label={disabledMessage}
          color="text-ds-natural-400"
        />
      </div>
    </Popover>
  ) : (
    Content
  );
};

export default DropdownItem;
